import type { StoryItem } from "../data/types";

export function ItemCard({
  item,
  onClick,
}: {
  item: StoryItem;
  onClick: () => void;
}) {
  return (
    <button
      onClick={onClick}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        padding: "12px 16px",
        backgroundColor: "white",
        border: "1px solid #e5e7eb",
        borderRadius: 10,
        cursor: "pointer",
        textAlign: "left",
        transition: "box-shadow 0.15s, border-color 0.15s",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = "#c7d2fe";
        e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.06)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = "#e5e7eb";
        e.currentTarget.style.boxShadow = "none";
      }}
    >
      <span style={{ fontSize: 22 }}>{item.emoji}</span>
      <span style={{ fontFamily: "var(--font-heading)", fontWeight: 600, fontSize: 15, color: "#111827" }}>
        {item.name}
      </span>
    </button>
  );
}
